/**
 * ModernAdminModals - Enhanced modals for admin operations
 */
import React from 'react';
import OriginalModals from './AdminModals';

// For now, we'll use the existing modals as they already work well
// In a future iteration, we can enhance these modals with modern design
const ModernAdminModals = (props) => {
  return <OriginalModals {...props} />;
};

export default ModernAdminModals;
